import { Box, Card, CardContent, Typography } from "@mui/joy";
import { EstimateContractTabs } from ".";

export default function EstimateContract(props: any) {
    const { measurements, setIsNextStageEligible } = props;
    return (
        <Box>
            <Box mt={2}>
                <EstimateContractTabs measurements={measurements} setIsNextStageEligible={setIsNextStageEligible} />
            </Box>
        </Box>
    );
}
